<template>
    <div>
        <Breadcrumbs v-if="role === 'admin'" main="Admin" submain="Complaints" :title="complaintTitle" />
        <Breadcrumbs v-else-if="role === 'road'" main="User" submain="Complaints" title="রাস্তা (Road)" />
        <Breadcrumbs v-else-if="role === 'mosquito'" main="User" submain="Complaints" title="মশা (Mosquito)" />
        <Breadcrumbs v-else-if="role === 'garbage'" main="User" submain="Complaints" title="বর্জ্য (Waste)" />
        <Breadcrumbs v-else-if="role === 'street_light'" main="User" submain="Complaints" title="রাস্তার বাতি (Street Light)" />

        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div style="width: 100%; display: flex; justify-content: end; align-items: end; margin-bottom: 20px;">
                                <div style="color: white; background-color: #00984a; padding: 8px 14px; border-radius: 5px; cursor: pointer;"  @click="downloadCSV">
                                    <h7>Download CSV</h7>
                                </div>
                            </div>
                            <b-row class="d-flex justify-content-center align-items-center">
                                <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="onchol || ward_no || selected_status || start_date || end_date">
                                        <feather type="x"></feather>
                                        <h7>Clear Filter</h7>
                                    </div>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="row mt-2">
                                <div class="col-md-3">
                                    <h7>অঞ্চল</h7>
                                    <b-form-select v-model="onchol" :options="formattedOnchols" @change="onOncholChange" placeholder="Select a Ward"></b-form-select>
                                </div>
                                <div class="col-md-3">
                                    <h7>ওয়ার্ড নং</h7>
                                    <b-form-select v-model="ward_no" :options="formattedWards" placeholder="Select a Ward"></b-form-select>
                                </div>
                                <div class="col-md-2">
                                    <h7>অবস্থা</h7>
                                    <b-form-select v-model="selected_status" :options="statuses" placeholder="Select a Status"></b-form-select>
                                </div>
                                <div class="col-md-2">
                                    <div>
                                        <h7>শুরুর তারিখ</h7>
                                        <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div>
                                        <h7>শেষ তারিখ</h7>
                                        <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                    </div>
                                </div>
                            </div>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue mt-4">
                                    <b-table show-empty stacked="md" :items="complain_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(name)="row">
                                            <div v-if="row.item.name" style="min-width: 150px;">
                                                <p>{{ row.item.name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(phone)="row">
                                            <div v-if="row.item.phone">
                                                <p>{{ row.item.phone }}</p>
                                            </div>
                                        </template>

                                        <template #cell(status)="row">
                                            <span
                                                v-if="row.item.status"
                                                :class="statusClasses[row.item.status]"
                                                class="status-pill"
                                                v-b-modal.modal-prevent-closing-priority
                                                @click="getStatus(row.item.status, row.item.tracking_id)"
                                            >
                                                {{ getStatusLabel(row.item.status) }}
                                            </span>
                                        </template>

                                        <template #cell(description)="row">
                                            <div v-if="row.item.description" style="max-width: 400px;">
                                                <p v-if="row.item.description?.length > 99">{{ row.item.description.slice(0, 100) }}...</p>
                                                <p v-else>{{ row.item.description }}</p>
                                            </div>
                                        </template>

                                        <template #cell(issue_submitted)="row">
                                            <div v-if="row.item.issue_submitted">
                                                <p>{{ formatDate(row.item.issue_submitted) }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="row">
                                            <span style="display: flex;">
                                                <!-- <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteComplain(row.item.id)" title="Delete"></feather>
                                                </div> -->
                                                <div @click="viewContact(row.item)" style="margin-left: 11px;">
                                                    <feather type="eye" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="অভিযোগ দেখুন" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <!-- View Complain Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="অভিযোগ দেখুন" size="lg">
            <div style="display: flex; flex-direction: column; gap: 16px;" id="section">
                   <div class="no-print d-flex justify-content-end">
                <div @click="printPdf('section')">
                    <b-button variant="success">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <feather type="printer" size="18px"></feather>
                            <h7>Print</h7>
                        </div>
                    </b-button>
                </div>
            </div>
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">ট্র্যাকিং আইডি (Tracking Id)</div> <div>{{ complain.tracking_id }} </div>
                </div>
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">ফোন নং (Phone No)</div> {{ complain.phone }} 
                </div>
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">নাম (Name)</div> {{ complain.name }} 
                </div>
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">অবস্থান (Location)</div> {{ complain.location }} 
                </div>
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">ওয়ার্ড নং (Ward No)</div> <div v-if="complain.ward_no">{{ complain.ward_no.bangla_name }} ({{ complain.ward_no.name }})</div>
                </div>
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">সমস্যার ধরন (Issue Type)</div> {{ complain.issue_type }} 
                </div>
                <div style="display: flex; flex-direction: row; align-items: center;">
                    <div style="width: 210px; font-weight: 600;">অবস্থা (Status)</div> 
                    <div>
                        <span
                            v-if="complain.status"
                            :class="statusClasses[complain.status]"
                            class="status-pill"
                        >
                            {{ getStatusLabel(complain.status) }}
                        </span>
                    </div>
                </div>
                <div style="display: flex; flex-direction: column; gap: 4px;">
                    <div style="width: 210px; font-weight: 600;">বিস্তারিত (Details)</div> 
                    <div>{{ complain.description }} </div>
                </div>
                <div v-if="complain.picture">
                    <div style="width: 210px; font-weight: 600;">ছবি (Image)</div>
                    <img style="max-height: 800px; max-width: 100%;" :src="host + complain.picture" alt="">
                </div>
            </div>
        </b-modal>

        <!-- Update Status -->
        <b-modal id="modal-prevent-closing-priority" ref="modal" title="অভিযোগের অবস্থা আপডেট করুন" @show="resetModal" @hidden="resetModal" @ok="handlePriorityOk">
            <form ref="form" @submit.stop.prevent="updateStatus">
                <b-form-group label="Status" label-for="name-input">
                    <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
                </b-form-group>
            </form>
        </b-modal>
    
        <!-- Complaint Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this complaint?</div>
        </b-modal>
    </div>
    </template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import loader from './loader/loader.vue';
    import Datepicker from 'vuejs-datepicker';
    import moment from "moment";
    
    export default {
        components: {
            loader,
            Datepicker
        },
    
        data() {
            return {
                host: 'https://api.fairdhaka.com',
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'tracking_id',
                        label: 'ট্র্যাকিং আইডি',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'নাম',
                        sortable: true
                    },
                    {
                        key: 'phone',
                        label: 'ফোন নং',
                        sortable: true
                    },
                    {
                        key: 'ward_no.bangla_name',
                        label: 'ওয়ার্ড নং',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'অবস্থা',
                        sortable: true
                    },
                    {
                        key: 'description',
                        label: 'বিস্তারিত',
                        sortable: true
                    },
                    {
                        key: 'issue_submitted',
                        label: 'তারিখ',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'দেখুন',
                        sortable: false
                    }
                ],
                complaintRoutes: [
                    { path: "/admin/complaints/road", title: "রাস্তা (Road)" },
                    { path: "/admin/complaints/mosquito", title: "মশা (Mosquito)" },
                    { path: "/admin/complaints/garbage", title: "বর্জ্য (Waste)" },
                    { path: "/admin/complaints/street_light", title: "রাস্তার বাতি (Street Light)" },
                    { path: "/admin/complaints/public_toilet", title: "পাবলিক টয়লেট (Public Toilet)" },
                    { path: "/admin/complaints/drainage", title: "নিষ্কাশন ব্যবস্থা (Drainage)" },
                    { path: "/admin/complaints/illegal_structure", title: "অবৈধ কাঠামো (Illegal Structure)" },
                    { path: "/admin/complaints/waterlog", title: "জলাবদ্ধতা (Waterlog)" },
                    { path: "/admin/complaints/air_pollution", title: "বায়ু দূষণ (Air Pollution)" },
                    { path: "/admin/complaints/noise_pollution", title: "শব্দ দূষণ (Noise Pollution)" },
                ], 
                onchol: null,
                ward_no: null,
                selected_status: null,
                start_date: null,
                end_date: null,
                complain: {}, // view complaint modal
                selectedStatus: '',
                update_tracking_id: '',
                delete_value: null,
                statuses: [
                    {
                        value: 'pending',
                        text: 'Pending'
                    },
                    {
                        value: 'acknowledged',
                        text: 'Acknowledged'
                    },
                    {
                        value: 'in_progress',
                        text: 'In Progress'
                    },
                    {
                        value: 'resolved',
                        text: 'Resolved'
                    },
                    {
                        value: 'rejected',
                        text: 'Rejected'
                    },
                ],
                role: '',
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20],
                headers: ['id', 'tracking_id', 'issue_submitted', 'name', 'phone', 'ward_no', 'location', 'picture', 'description'],
                columnWidths: {
                    id: 5,
                    name: 30,
                    ward_no: 15,
                    tracking_id: 25,
                    issue_submitted: 25,
                    picture: 25,
                    phone: 15,
                    location: 50,
                    description: 100
                }
            };
        },
    
        computed: {
            ...mapState({
                wards: state => state.issue.wards,
                onchols: state => state.issue.onchols,
                complain_list: state => state.issue.complain_list,
                loading: state => state.issue.contactLoading,
                error: state => state.issue.contactError
            }),

            statusClasses() {
                return {
                    pending: 'status-pending',
                    acknowledged: 'status-acknowledged',
                    in_progress: 'status-in-progress',
                    resolved: 'status-resolved',
                    rejected: 'status-rejected'
                };
            },

            complaintTitle() {
                const currentPath = this.$route.path;
                const match = this.complaintRoutes.find(route => route.path === currentPath);
                return match ? match.title : "অজানা অভিযোগ (Unknown Complaint)";
            },
    
            formattedWards() {
                return this.wards.map(ward => {
                    return {
                        value: ward?.id,
                        text: `${ward?.bangla_name} (${ward?.name})`
                    };
                });
            },
            
            formattedOnchols() {
                return this.onchols.map(onchol => {
                    return {
                        value: onchol?.id,
                        text: `${onchol?.bangla_name} (${onchol?.name})`
                    };
                });
            }
        },

        watch: {
            '$route.params.id': 'onIdChange',

            complain_list(newVal, oldVal) {
                this.items = newVal;
                this.totalRows = newVal.length;
                this.currentPage = 1;
            },

            onchol() {
                this.updateQuery();
            },
            ward_no() {
                this.updateQuery();
            },
            selected_status() {
                this.updateQuery();
            },
            start_date() {
                this.updateQuery();
            },
            end_date() {
                this.updateQuery();
            },

            // ward_no(newVal, oldVal) {
            //     if(this.ward_no !== null  && this.start_date == null && this.end_date == null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no
            //             }
            //         });
            //     } else if (this.ward_no !== null && this.start_date !== null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no,
            //                 start_date: this.start_date,
            //                 end_date: this.end_date
            //             }
            //         });
            //     } else if (this.ward_no !== null && this.start_date !== null && this.end_date == null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no,
            //                 start_date: this.start_date
            //             }
            //         });
            //     } else if (this.ward_no !== null && this.start_date == null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no,
            //                 end_date: this.end_date
            //             }
            //         });
            //     } 
            //     // else {
            //     //     this.$router.replace({
            //     //         path: this.$route.path
            //     //     });
            //     // }

            //     this.$store.dispatch("issue/filterComplaints", {
            //         category: this.$route.params.id,
            //         ward_no: this.ward_no,
            //         start_date: this.$route.query.start_date,
            //         end_date: this.$route.query.end_date
            //     }).then(() => {
            //         this.items = this.complain_list
            //         this.totalRows = this.complain_list.length;
            //     });
            // },

            // start_date(newVal, oldVal) {
            //     this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");

            //     if(this.ward_no == null && this.start_date !== null && this.end_date == null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 start_date: this.start_date
            //             }
            //         });
            //     } else if (this.ward_no !== null && this.start_date !== null && this.end_date == null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no,
            //                 start_date: this.start_date 
            //             }
            //         });
            //     } else if (this.ward_no !== null && this.start_date !== null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no,
            //                 start_date: this.start_date,
            //                 end_date: this.end_date
            //             }
            //         });
            //     } else if (this.ward_no == null && this.start_date !== null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 start_date: this.start_date,
            //                 end_date: this.end_date
            //             }
            //         });
            //     } 
            //     // else {
            //     //     this.$router.replace({
            //     //         path: this.$route.path
            //     //     });
            //     // }

            //     this.$store.dispatch("issue/filterComplaints", {
            //         category: this.$route.params.id,
            //         ward_no: this.$route.query.ward_no,
            //         start_date: this.start_date,
            //         end_date: this.$route.query.end_date
            //     }).then(() => {
            //         this.items = this.complain_list
            //         this.totalRows = this.complain_list.length;
            //     });
            // },

            // end_date(newVal, oldVal) {
            //     this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");

            //     if(this.ward_no == null && this.start_date == null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 end_date: this.end_date
            //             }
            //         });
            //     } else if (this.ward_no !== null && this.start_date == null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no,
            //                 end_date: this.end_date
            //             }
            //         });
            //     } else if (this.ward_no !== null && this.start_date !== null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 ward_no: this.ward_no,
            //                 start_date: this.start_date,
            //                 end_date: this.end_date
            //             }
            //         });
            //     } else if (this.ward_no == null && this.start_date !== null && this.end_date !== null) {
            //         this.$router.replace({
            //             path: this.$route.path,
            //             query: {
            //                 start_date: this.start_date,
            //                 end_date: this.end_date
            //             }
            //         });
            //     } 
            //     // else {
            //     //     this.$router.replace({
            //     //         path: this.$route.path
            //     //     });
            //     // }

            //     this.$store.dispatch("issue/filterComplaints", {
            //         category: this.$route.params.id,
            //         ward_no: this.$route.query.ward_no,
            //         start_date: this.$route.query.start_date,
            //         end_date: this.end_date
            //     }).then(() => {
            //         this.items = this.complain_list
            //         this.totalRows = this.complain_list.length;
            //     });
            // }
        },
    
        mounted() {
            this.role = localStorage.getItem("role");
            this.$store.dispatch('issue/getWards')
            this.$store.dispatch('issue/getOnchols')
            // this.$store.dispatch("issue/filterComplaints", {category: this.$route.params.id}).then((response) => {
            //     this.complain_list = response.data;
            //     this.totalRows = this.complain_list.length;
            // });
            this.initializeComplaints();
        },
    
        methods: {
            printPdf(section) {
            this.downloadPdf = true;

            const printContents = document.getElementById(section).innerHTML;
            const originalContents = document.body.innerHTML;
          const wrappedPrintContents = `<div class="page" style="margin: 80px;">${printContents}</div>`;

            document.body.innerHTML = wrappedPrintContents;

            window.print();

          
            document.body.innerHTML = originalContents;

            location.reload();
        },
            pad(str, length, field) {
                str = str ?? '';
                str = str.toString().replace(/\r?\n|\r/g, ' '); // remove newlines

                if (field === 'description') {
                    return str;  // 👈 return full description, no truncation or padding
                }

                if (str.length > length) {
                    return str.slice(0, length - 3) + '...';  // truncate and add ellipsis
                } else {
                    return str.padEnd(length, ' ');
                }
            },

            escapeCSV(value) {
                if (typeof value !== 'string') return value;
                if (value.includes('"')) {
                    value = value.replace(/"/g, '""'); // escape quotes
                }
                if (value.includes(',') || value.includes('\n') || value.includes('"')) {
                    return `"${value}"`; // wrap in quotes if needed
                }
                return value;
            },

            downloadCSV() {
                if (!this.headers || !this.headers.length) {
                    alert('No headers defined');
                    return;
                }

                if (!this.complain_list || !this.complain_list.length) {
                    alert('No data to export');
                    return;
                }

                // Pad and escape headers
                const paddedHeaders = this.headers.map(field => {
                    const padded = this.pad(field, this.columnWidths[field], field);
                    return this.escapeCSV(padded);
                });

                // Pad and escape each row
                const rows = this.complain_list.map(item =>
                    this.headers.map(field => {
                        let value;

                        if (field === 'ward_no') {
                            value = item.ward_no?.bangla_name ? item.ward_no.bangla_name : '';
                        } else if (field === 'issue_submitted') {
                            // Format date as YYYY-MM-DD
                            const date = item.issue_submitted ? new Date(item.issue_submitted) : null;
                            value = date ? date.toISOString().split('T')[0] : '';
                        } else if (field === 'picture') {
                            // Add host URL before picture filename
                            value = item.picture ? `${this.host}${item.picture}` : '';
                        } else {
                            value = item[field];
                        }

                        // ✅ Do NOT pad description or picture → keep full value
                        if (field === 'description' || field === 'picture') {
                            return this.escapeCSV(value ?? '');
                        }

                        const padded = this.pad(value, this.columnWidths[field], field);
                        return this.escapeCSV(padded);
                    }).join(',')
                );

                const csvContent = [paddedHeaders.join(','), ...rows].join('\n');

                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'complain_list.csv');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },

            getStatus(status, id) {
                this.update_tracking_id = id
                this.selectedStatus = status
            },

            resetModal() {
                this.ticket.subject = null
                this.ticket.refer_to = null
            },

            handlePriorityOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.updateStatus()
            },
            
            updateStatus() {
                this.$store.dispatch("issue/updateComplainStatus", {
                    id: this.update_tracking_id,
                    update_status: this.selectedStatus,
                    category: this.$route.params.id
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "সফল হয়েছে!",
                            text: 'স্ট্যাটাস সফলভাবে আপডেট হয়েছে',
                            icon: "success"
                        });
                        this.update_tracking_id= ''
                        this.selectedStatus= ''
                    } else {
                        Swal.fire({
                            title: "ভুল হয়েছে!",
                            text: 'স্ট্যাটাস সফলভাবে আপডেট হয়নি',
                            icon: "error"
                        });
                    }
                })
                // Hide the modal manually
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-priority')
                })
            },

            initializeComplaints() {
                const { ward_no, onchol, selected_status, start_date, end_date } = this.$route.query;

                if (ward_no || onchol || selected_status || start_date || end_date) {
                    this.onchol = onchol || null;
                    this.ward_no = ward_no || null;
                    this.selected_status = selected_status || null;
                    this.start_date = start_date || null;
                    this.end_date = end_date || null;

                    this.fetchFilteredComplaints();
                } else {
                    if(this.role === 'admin') {
                        this.$store.dispatch("issue/filterComplaints", {
                            category: this.$route.params.id
                        }).then((response) => {
                            this.complain_list = response.data;
                            this.totalRows = this.complain_list.length;
                        }).catch(error => {
                            console.error("Failed to fetch complaints:", error);
                        });
                    } else if(this.role === 'street_light') {
                        this.$store.dispatch("issue/filterComplaints", {
                            category: 'street_light'
                        }).then((response) => {
                            this.complain_list = response.data;
                            this.totalRows = this.complain_list.length;
                        }).catch(error => {
                            console.error("Failed to fetch complaints:", error);
                        });
                    } else if(this.role === 'garbage') {
                        this.$store.dispatch("issue/filterComplaints", {
                            category: 'garbage'
                        }).then((response) => {
                            this.complain_list = response.data;
                            this.totalRows = this.complain_list.length;
                        }).catch(error => {
                            console.error("Failed to fetch complaints:", error);
                        });
                    } else if(this.role === 'mosquito') {
                        this.$store.dispatch("issue/filterComplaints", {
                            category: 'mosquito'
                        }).then((response) => {
                            this.complain_list = response.data;
                            this.totalRows = this.complain_list.length;
                        }).catch(error => {
                            console.error("Failed to fetch complaints:", error);
                        });
                    } else if(this.role === 'road') {
                        this.$store.dispatch("issue/filterComplaints", {
                            category: 'road'
                        }).then((response) => {
                            this.complain_list = response.data;
                            this.totalRows = this.complain_list.length;
                        }).catch(error => {
                            console.error("Failed to fetch complaints:", error);
                        });
                    }
                }
            },

            onOncholChange() {
                this.$store.dispatch('issue/getWardsByOnchol', this.onchol)
            },

            updateQuery() {
                const query = {};

                if (this.onchol) query.onchol = this.onchol;
                if (this.ward_no) query.ward_no = this.ward_no;
                if (this.selected_status) query.selected_status = this.selected_status;
                if (this.start_date) query.start_date = this.formatDate(this.start_date);
                if (this.end_date) query.end_date = this.formatDate(this.end_date);

                // Update the route without reloading the page
                this.$router.replace({ path: this.$route.path, query });

                this.fetchFilteredComplaints();
            },

            formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = `${d.getMonth() + 1}`.padStart(2, '0');
                const day = `${d.getDate()}`.padStart(2, '0');
                return `${d.getFullYear()}-${month}-${day}`;
            },

            fetchFilteredComplaints() {
                if(this.role === 'admin') {
                    this.$store.dispatch("issue/filterComplaints", {
                        category: this.$route.params.id,
                        ward_no: this.$route.query.ward_no,
                        status: this.$route.query.selected_status,
                        onchol: this.$route.query.onchol,
                        start_date: this.$route.query.start_date,
                        end_date: this.$route.query.end_date
                    }).then(() => {
                        this.items = this.complain_list;
                        this.totalRows = this.complain_list.length;
                    }).catch(error => {
                        console.error("Failed to fetch complaints:", error);
                    });
                } else if(this.role === 'road') {
                    this.$store.dispatch("issue/filterComplaints", {
                        category: this.role,
                        ward_no: this.$route.query.ward_no,
                        status: this.$route.query.selected_status,
                        onchol: this.$route.query.onchol,
                        start_date: this.$route.query.start_date,
                        end_date: this.$route.query.end_date
                    }).then(() => {
                        this.items = this.complain_list;
                        this.totalRows = this.complain_list.length;
                    }).catch(error => {
                        console.error("Failed to fetch complaints:", error);
                    });
                } else if(this.role === 'mosquito') {
                    this.$store.dispatch("issue/filterComplaints", {
                        category: this.role,
                        ward_no: this.$route.query.ward_no,
                        status: this.$route.query.selected_status,
                        onchol: this.$route.query.onchol,
                        start_date: this.$route.query.start_date,
                        end_date: this.$route.query.end_date
                    }).then(() => {
                        this.items = this.complain_list;
                        this.totalRows = this.complain_list.length;
                    }).catch(error => {
                        console.error("Failed to fetch complaints:", error);
                    });
                } else if(this.role === 'garbage') {
                    this.$store.dispatch("issue/filterComplaints", {
                        category: this.role,
                        ward_no: this.$route.query.ward_no,
                        status: this.$route.query.selected_status,
                        onchol: this.$route.query.onchol,
                        start_date: this.$route.query.start_date,
                        end_date: this.$route.query.end_date
                    }).then(() => {
                        this.items = this.complain_list;
                        this.totalRows = this.complain_list.length;
                    }).catch(error => {
                        console.error("Failed to fetch complaints:", error);
                    });
                } else if(this.role === 'street_light') {
                    this.$store.dispatch("issue/filterComplaints", {
                        category: this.role,
                        ward_no: this.$route.query.ward_no,
                        status: this.$route.query.selected_status,
                        onchol: this.$route.query.onchol,
                        start_date: this.$route.query.start_date,
                        end_date: this.$route.query.end_date
                    }).then(() => {
                        this.items = this.complain_list;
                        this.totalRows = this.complain_list.length;
                    }).catch(error => {
                        console.error("Failed to fetch complaints:", error);
                    });
                }
            },

            viewContact(data) {
                this.complain = data;
            },

            clearFilter() {
                this.onchol = null;
                this.ward_no = null;
                this.selected_status = null;
                this.start_date = null;
                this.end_date = null;

                this.$nextTick(() => {
                    this.$router.replace({
                        path: `/admin/complaints/${this.$route.params.id}`, query: {}
                    });
                });
            },

            onIdChange(newId, oldId) {
                this.$store.dispatch("issue/filterComplaints", {category: this.$route.params.id}).then((response) => {
                    // console.log(response.data)
                    this.complain_list = response.data;
                });
            },

            getStatusLabel(status) {
                const found = this.complain_list.find(item => item.status === status);
                return found ? found.status : status.replace('_', ' ');
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("contact/addContact", {
                    contact: this.contact
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.contact.name = null
                        this.contact.phone = null
                        this.contact.contact_type  = null
                        this.contact.shelter = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            deleteComplain(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("issue/deleteComplain", {
                    delete: this.delete_value,
                    category: this.$route.params.id
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
    </script>

    <style scoped>
.status-pill {
  padding: 2px 8px;
  border-radius: 9999px;
  color: white;
  font-size: 0.875rem; /* text-sm */
  text-transform: capitalize;
  display: inline-block;
}

/* Define colors manually */
.status-pending {
  background-color: #facc15; /* Yellow */
}

.status-acknowledged {
  background-color: #3b82f6; /* Blue */
}

.status-in-progress {
  background-color: #8b5cf6; /* Purple */
}

.status-resolved {
  background-color: #22c55e; /* Green */
}

.status-rejected {
  background-color: #ef4444; /* Red */
}

@media print {

    .no-print {
        display: none !important;
    }
}
</style>
    